// extracted by mini-css-extract-plugin
export var askAiIcon = "_o8-j";
export var category = "_o8-9";
export var categoryHeader = "_o8-e";
export var container = "_o8-0";
export var group = "_o8-a";
export var groupItems = "_o8-f";
export var groupSeparator = "_o8-k";
export var loading = "_o8-1";
export var noResults = "_o8-3";
export var placeholder = "_o8-2";
export var resultContent = "_o8-5";
export var resultIcon = "_o8-c";
export var resultItem = "_o8-g";
export var resultMeta = "_o8-8";
export var resultSubtitle = "_o8-7";
export var resultSuffix = "_o8-i";
export var resultTitle = "_o8-6";
export var resultsList = "_o8-4";
export var searchGroup = "_o8-d";
export var selected = "_o8-h";
export var subgroup = "_o8-b";